// useReports.js
import { useQuery } from "@tanstack/react-query";
import {
  getAgentWalletAnalytics,
  getFlightPostTicketingFees,
  getFlightRevenueByAirline,
  getFlightRevenueStreams,
  getFlightRevenueTrends,
  getFlightSummaryMetrics,
  getFlightTopRoutes,
  getHotelBreakdowns,
  getHotelRankings,
  getHotelRevenueStreams,
  getHotelRevenueTrends,
  getHotelSummaryMetrics,
  getInsuranceBreakdowns,
  getInsuranceRankings,
  getInsuranceRevenueStreams,
  getInsuranceRevenueTrends,
  getInsuranceSummaryMetrics,
  getNobiPackageCategories,
  getNobiPackageBreakdowns,
  getNobiPackageRankings,
  getNobiPackageRevenueStreams,
  getNobiPackageRevenueTrends,
  getNobiPackageSummaryMetrics,
  getPackageBreakdowns,
  getPackageRankings,
  getPackageRevenueStreams,
  getPackageRevenueTrends,
  getPackageSummaryMetrics,
  getRevenueBycategory,
  getRevenueByClass,
  getRevenueByGeography,
  getRevenueTrends,
  getSubscriptionReport,
  getSummaryMetrics,
  getTopAirlines,
  getTopRevenueAgents,
  getTransaction,
  getWalletActivityTrends,
  getWalletHighValueActivity,
  getWalletSummary,
  getWalletTopHolders,
  getWalletTransactionDistribution,
} from "../api/reportDashboardApi";

export const useSummaryMetrics = (dateRange) => {
  return useQuery({
    queryKey: ["summaryMetrics", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getSummaryMetrics(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
export const useRevenuetrends = (dateRange) => {
  return useQuery({
    queryKey: ["revenueTrends", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getRevenueTrends(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
export const useRevenueBycategory = (dateRange) => {
  return useQuery({
    queryKey: ["revenueBycategory", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getRevenueBycategory(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
export const useTopRevenueAgents = (dateRange) => {
  return useQuery({
    queryKey: ["topRevenueAgents", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getTopRevenueAgents(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
export const useFlightRevenueByAirline = (dateRange) => {
  return useQuery({
    queryKey: [
      "flightRevenueByAirline",
      dateRange?.startDate,
      dateRange?.endDate,
    ],
    queryFn: () => getFlightRevenueByAirline(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
export const useRevenueByGeography = (dateRange) => {
  return useQuery({
    queryKey: ["revenueByGeography", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getRevenueByGeography(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
export const useSubscriptionsReport = (dateRange) => {
  return useQuery({
    queryKey: ["subscriptions", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getSubscriptionReport(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

// flight report
export const useFlightSummaryMetrics = (dateRange) => {
  return useQuery({
    queryKey: ["flightSummaryMetrics", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getFlightSummaryMetrics(dateRange),
    staleTime: 1 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useFlightRevenueTrends = (dateRange) => {
  return useQuery({
    queryKey: ["flightRevenueTrends", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getFlightRevenueTrends(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
export const useFlightRevenueStreams = (dateRange) => {
  return useQuery({
    queryKey: ["flightRevenueStreams", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getFlightRevenueStreams(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
export const useFlightTopRoutes = (dateRange) => {
  return useQuery({
    queryKey: ["flightTopRoutes", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getFlightTopRoutes(dateRange),
    staleTime: 1 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
export const useFlightPostTicketingFees = (dateRange) => {
  return useQuery({
    queryKey: [
      "flightPostTicketingFees",
      dateRange?.startDate,
      dateRange?.endDate,
    ],
    queryFn: () => getFlightPostTicketingFees(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

// Revenue by class
export const useRevenueByClass = (dateRange) => {
  return useQuery({
    queryKey: ["revenueByClass", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getRevenueByClass(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

// Top airlines
export const useTopAirlines = (dateRange) => {
  return useQuery({
    queryKey: ["topAirlines", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getTopAirlines(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useHotelSummaryMetrics = (dateRange) => {
  return useQuery({
    queryKey: ["hotelSummaryMetrics", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getHotelSummaryMetrics(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useHotelRevenueStreams = (dateRange) => {
  return useQuery({
    queryKey: ["hotelRevenueStreams", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getHotelRevenueStreams(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useHotelRevenueTrends = (dateRange) => {
  return useQuery({
    queryKey: ["hotelRevenueTrends", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getHotelRevenueTrends(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useHotelBreakdowns = (dateRange) => {
  return useQuery({
    queryKey: ["hotelBreakdowns", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getHotelBreakdowns(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useHotelRankings = (dateRange) => {
  return useQuery({
    queryKey: ["hotelRankings", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getHotelRankings(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const usePackageSummaryMetrics = (dateRange) => {
  return useQuery({
    queryKey: ["packageSummaryMetrics", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getPackageSummaryMetrics(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const usePackageRevenueStreams = (dateRange) => {
  return useQuery({
    queryKey: ["packageRevenueStreams", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getPackageRevenueStreams(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const usePackageRevenueTrends = (dateRange) => {
  return useQuery({
    queryKey: ["packageRevenueTrends", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getPackageRevenueTrends(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const usePackageBreakdowns = (dateRange) => {
  return useQuery({
    queryKey: ["packageBreakdowns", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getPackageBreakdowns(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const usePackageRankings = (dateRange) => {
  return useQuery({
    queryKey: ["packageRankings", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getPackageRankings(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useInsuranceSummaryMetrics = (dateRange) => {
  return useQuery({
    queryKey: [
      "insuranceSummaryMetrics",
      dateRange?.startDate,
      dateRange?.endDate,
    ],
    queryFn: () => getInsuranceSummaryMetrics(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useInsuranceRevenueStreams = (dateRange) => {
  return useQuery({
    queryKey: [
      "insuranceRevenueStreams",
      dateRange?.startDate,
      dateRange?.endDate,
    ],
    queryFn: () => getInsuranceRevenueStreams(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useInsuranceRevenueTrends = (dateRange) => {
  return useQuery({
    queryKey: [
      "insuranceRevenueTrends",
      dateRange?.startDate,
      dateRange?.endDate,
    ],
    queryFn: () => getInsuranceRevenueTrends(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useInsuranceBreakdowns = (dateRange) => {
  return useQuery({
    queryKey: [
      "insuranceBreakdowns",
      dateRange?.startDate,
      dateRange?.endDate,
    ],
    queryFn: () => getInsuranceBreakdowns(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useInsuranceRankings = (dateRange) => {
  return useQuery({
    queryKey: ["insuranceRankings", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getInsuranceRankings(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useNobiPackageSummaryMetrics = (dateRange) => {
  return useQuery({
    queryKey: [
      "nobiPackageSummaryMetrics",
      dateRange?.startDate,
      dateRange?.endDate,
    ],
    queryFn: () => getNobiPackageSummaryMetrics(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useNobiPackageCategories = () => {
  return useQuery({
    queryKey: ["nobiPackageCategories"],
    queryFn: getNobiPackageCategories,
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useNobiPackageRevenueStreams = (dateRange) => {
  return useQuery({
    queryKey: [
      "nobiPackageRevenueStreams",
      dateRange?.startDate,
      dateRange?.endDate,
    ],
    queryFn: () => getNobiPackageRevenueStreams(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useNobiPackageRevenueTrends = (dateRange) => {
  return useQuery({
    queryKey: [
      "nobiPackageRevenueTrends",
      dateRange?.startDate,
      dateRange?.endDate,
    ],
    queryFn: () => getNobiPackageRevenueTrends(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useNobiPackageBreakdowns = (dateRange) => {
  return useQuery({
    queryKey: [
      "nobiPackageBreakdowns",
      dateRange?.startDate,
      dateRange?.endDate,
    ],
    queryFn: () => getNobiPackageBreakdowns(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useNobiPackageRankings = (dateRange) => {
  return useQuery({
    queryKey: [
      "nobiPackageRankings",
      dateRange?.startDate,
      dateRange?.endDate,
    ],
    queryFn: () => getNobiPackageRankings(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useWalletSummary = () => {
  return useQuery({
    queryKey: ["walletSummary"],
    queryFn: getWalletSummary,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useWalletActivityTrends = () => {
  return useQuery({
    queryKey: ["walletActivityTrends"],
    queryFn: getWalletActivityTrends,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useWalletTransactionDistribution = () => {
  return useQuery({
    queryKey: ["walletTransactionDistribution"],
    queryFn: getWalletTransactionDistribution,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useWalletTopHolders = () => {
  return useQuery({
    queryKey: ["walletTopHolders"],
    queryFn: getWalletTopHolders,
    staleTime: 1 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useWalletHighValueActivity = () => {
  return useQuery({
    queryKey: ["walletHighValueActivity"],
    queryFn: getWalletHighValueActivity,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useAgentWalletAnalytics = () => {
  return useQuery({
    queryKey: ["agentWalletAnalytics"],
    queryFn: getAgentWalletAnalytics,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useTransaction = (dateRange) => {
  return useQuery({
    queryKey: ["transaction", dateRange?.startDate, dateRange?.endDate],
    queryFn: () => getTransaction(dateRange),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
